export var CONTAINER_CLASS_PREFIX = 'Container';